import React, { useEffect, useState } from "react";
import Label from "../../../components/Label";
import { useSelector } from "react-redux";
import Box from "../../../components/Box";
import styled from "styled-components";
import PieChartMethod from "./PieChartMethod";
import { useTranslation } from "react-i18next";
const HeaderBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PlanMembers = ({stats={}}) => {
  const [isSegmentChange, setIsSegmentChange] = useState(true);
  const {t} = useTranslation()
  const getDataMethod = () => {
    let data = [];
    const { auto, manual, free } = stats?.paymentTypeCounts || {};
    const { isDeactivated } = stats?.userInactiveStatus || {};
    
    data.push({
      count: free ? free : 0,
      _id: { current_status: "free" },
    });
    data.push({
      count: auto ? auto : 0,
      _id: { current_status: "auto" },
    });
    data.push({
      count: manual ? manual : 0,
      _id: { current_status: "manual" },
    });
    data.push({
      count: isDeactivated ? isDeactivated : 0,
      _id: { current_status: true },
    });
    return data;
  };
  return (
    <div className="col-md-5 col-lg-4">
      <div className="plan-members">
        <HeaderBox>
          <Box>
            <Label variant="text1" className="overview-head">{t('Membership Members')}</Label>
          </Box>
        </HeaderBox>
        <Label variant="text5" color="#7E7E7E"  className="overview-disc">
        {t('Total Number of Registered Members')}
        </Label>
          <div className="white_box" style={{ height: "85%" }}>
            {stats?.total_entity_count ? (
              <div className="" style={{ height: "100%" }}>
                <div style={{ height: "100%" }}>
                  <PieChartMethod
                    pieData={getDataMethod()}
                    bg={"white"}
                    padAngle={0}
                    padRadius={0}
                    cornerRadius={0}
                  />
                </div>
              </div>
            ):<div className="d-flex justify-content-center align-items-center h-100">No data</div>}
          </div>
        

          
      </div>
    </div>
  );
};

export default PlanMembers;
